export default "__VITE_ASSET__InGUar4C__"